import type * as React from "react";

import { cn } from "./cn";

// Player
export type PlayerControlButtonColor = "black" | "white";

export type SeekBarColor = "black" | "white";

export const WHITE_AUDIO_TRACK_BACKGROUND =
  "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%), linear-gradient(90deg, rgba(16, 16, 16, 0.15) 0%, rgba(16, 16, 16, 0.15) 100%)";

export const SEEK_BAR_FOCUS_RING_CLASSES =
  "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";

export function getSeekBarBackdropBlurStyle(
  color: SeekBarColor,
): React.CSSProperties | undefined {
  if (color !== "white") {
    return undefined;
  }

  return {
    backdropFilter: "blur(40px)",
    WebkitBackdropFilter: "blur(40px)",
  };
}

export function getSeekBarWhiteTrackStyle(
  color: SeekBarColor,
): React.CSSProperties | undefined {
  if (color !== "white") {
    return undefined;
  }

  return {
    backgroundImage: WHITE_AUDIO_TRACK_BACKGROUND,
    ...getSeekBarBackdropBlurStyle(color),
  };
}

type PlayerControlButtonClassesOptions = {
  color: PlayerControlButtonColor;
  disabled?: boolean;
};

export function getPlayerControlButtonClasses({
  color,
  disabled = false,
}: PlayerControlButtonClassesOptions) {
  return cn("rounded-full", getPlayerControlButtonStateClasses(color), {
    "cursor-not-allowed": disabled,
  });
}

function getPlayerControlButtonStateClasses(color: PlayerControlButtonColor) {
  return cn(
    "transition-colors duration-300 hover:text-twi-gray-300 active:text-twi-gray-300 disabled:text-twi-gray-500",
    { "text-white": color === "white", "text-black": color === "black" },
  );
}
